import React from "react";
import VoiceKnowledgeApp from "./VoiceKnowledgeApp";

function App() {
  return <VoiceKnowledgeApp />;
}

export default App;